import { createAction, props } from '@ngrx/store';
import { PaymentMandateResponse } from '../models/payment-mandate.model';

export const loadAcceptPaymentMandates = createAction(
  '[AcceptPaymentMandate] Load AcceptPaymentMandates',
  props<{ businessId: string; mandate: PaymentMandateResponse }>()
);

export const loadAcceptPaymentMandatesSuccess = createAction(
  '[AcceptPaymentMandate] Load AcceptPaymentMandates Success',
  props<{ response: any }>()
);

export const loadAcceptPaymentMandatesFailure = createAction(
  '[AcceptPaymentMandate] Load AcceptPaymentMandates Failure',
  props<{ error: Error | any }>()
);

export const paymentMandateAccepted = createAction('[AcceptPaymentMandate] Payment Mandate Accepted', props<{ accepted: boolean }>());
